import React, { useContext, useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';
import { AssistantContext } from '../context/AssistantContext';
import arrowLeft from '../assets/arrow-left.png';
import arrowRight from '../assets/arrow-right.png';
import './Header.css';
import {
  doc,
  onSnapshot,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../firebase';
import bellIcon from '../assets/bell-icon.png';
import { useAuth } from '../context/AuthContext';
import freeConversationsIcon from '../assets/icon-free-conversations.png';
import paidConversationsIcon from '../assets/icon-paid-conversations.png';
import updateIcon from '../assets/actualizaciones-icon.png';


const Header = ({ toggleWideSidebar, isWideSidebarVisible }) => {
  const { isLightMode } = useContext(ThemeContext);
  const { assistantName } = useContext(AssistantContext);
  const { currentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [totalThreadsUsed, setTotalThreadsUsed] = useState(0);
  const [purchasedThreadsAvailable, setPurchasedThreadsAvailable] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [daysLeftSub, setDaysLeftSub] = useState(0);

  const [remainingFreeConversations, setRemainingFreeConversations] = useState(6000);
  const [remainingPaidConversations, setRemainingPaidConversations] = useState(0);

 const LATEST_UPDATE_VERSION = 'v15';

  
  
  // refs para detectar clics fuera
const updateButtonRef = useRef(null);
const updateModalRef  = useRef(null);


  // Extraer el assistantId de la URL si existe
  // Podríamos tener paths como: /messages/asst_xxx o /chat/asst_xxx
  // Suponemos un patrón: /messages/asst_{id} o /chat/asst_{id}
  let assistantIdFromURL = null;
  const msgMatch = location.pathname.match(/^\/messages\/(asst_[^/]+)/);
  const chatMatch = location.pathname.match(/^\/chat\/(asst_[^/]+)/);

  if (msgMatch) {
    assistantIdFromURL = msgMatch[1]; // asst_fBFPIR6fGR1wQHVmNXydPPWv
  } else if (chatMatch) {
    assistantIdFromURL = chatMatch[1];
  }

useEffect(() => {
  if (!currentUser) {
    console.warn('Usuario no autenticado');
    return;
  }

  const userDocRef = doc(db, 'users', currentUser.uid);

  // 👉 Inicializar lastSeenUpdateVersion si no existe
  (async () => {
    try {
      const snap = await getDoc(userDocRef);
      if (snap.exists()) {
        const data = snap.data();
        if (!data.lastSeenUpdateVersion) {
          await updateDoc(userDocRef, { lastSeenUpdateVersion: LATEST_UPDATE_VERSION });
        }
      } else {
        await setDoc(userDocRef, { lastSeenUpdateVersion: LATEST_UPDATE_VERSION }, { merge: true });
      }
    } catch (err) {
      console.error('Error inicializando lastSeenUpdateVersion:', err);
    }
  })();
    const unsubscribeUser = onSnapshot(userDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const userData = docSnapshot.data();
        const totalThreadsUsed = userData.totalThreads || 0;
        const purchasedThreadsAvailable = userData.purchasedThreads || 0;

const lastSeenUpdateVersion = userData.lastSeenUpdateVersion || null;
setShowUpdateNotificationIndicator(lastSeenUpdateVersion !== LATEST_UPDATE_VERSION);
// 👆 Solo mostramos el puntito si hay novedades. NO abrimos el modal acá.

        setTotalThreadsUsed(totalThreadsUsed);
        setPurchasedThreadsAvailable(purchasedThreadsAvailable);

        const baseFreeConversations = 6000;
        const remainingFree = Math.max(0, baseFreeConversations - totalThreadsUsed);
        const remainingPaid = Math.max(0, purchasedThreadsAvailable);


        setRemainingFreeConversations(remainingFree);
        setRemainingPaidConversations(remainingPaid);

         // (b) NUEVO: calcular días hasta vencimiento
      if (userData.accessExpiresAt) {
        const expiresDate = userData.accessExpiresAt.toDate(); 
        const now = new Date();
        const diffMs = expiresDate - now;
        const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        setDaysLeftSub(diffDays > 0 ? diffDays : 0);
      } else {
        setDaysLeftSub(0);
      }
    
      }

    }, (error) => {
      console.error('Error en el listener del documento del usuario:', error);
    });

  return () => {
    unsubscribeUser();
  };
}, [currentUser]);

// Total = gratuitas + pagas
const totalRemainingConversations =
  remainingFreeConversations + remainingPaidConversations;

  // Agrega este estado:
const [showNotificationIndicator, setShowNotificationIndicator] = useState(false);
// --- Nuevos estados para notificaciones de actualizaciones ---
const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
const [showUpdateNotificationIndicator, setShowUpdateNotificationIndicator] = useState(false);

const userDocRef = currentUser ? doc(db, 'users', currentUser.uid) : null;

const markUpdateAsSeen = async () => {
  try {
    if (userDocRef) {
      await updateDoc(userDocRef, { lastSeenUpdateVersion: LATEST_UPDATE_VERSION });
    } else {
      // Fallback para visitantes anónimos (opcional)
      localStorage.setItem('lastSeenUpdateVersion', LATEST_UPDATE_VERSION);
    }
  } catch (err) {
    console.error('Error guardando versión vista:', err);
  }
};

// Y este useEffect para verificar la fecha cada vez que se monta el componente:
useEffect(() => {
  const today = new Date().toISOString().split('T')[0];
  const lastDismissed = localStorage.getItem("lastNotificationDismissDate");
  setShowNotificationIndicator(lastDismissed !== today);
}, []);

// Crea la función para manejar el clic en la campanita:
const handleBellClick = (e) => {
  e.stopPropagation();
  setIsModalOpen(prev => !prev);
  if (showNotificationIndicator) {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem("lastNotificationDismissDate", today);
    setShowNotificationIndicator(false);
  }
};

const handleUpdateClick = async (e) => {
  e.stopPropagation();

  // Si lo estamos CERRANDO y aún se mostraba el puntito rojo,
  // marcamos la versión como vista.
  if (isUpdateModalOpen && showUpdateNotificationIndicator) {
    await markUpdateAsSeen();
    setShowUpdateNotificationIndicator(false);
  }

  // Alterna la apertura/cierre del modal.
  setIsUpdateModalOpen(prev => !prev);
};

  // Determinar el título del encabezado basado en la ruta actual
  let headerTitle = 'Inicio';
  if (location.pathname.startsWith('/messages')) {
    headerTitle = 'Chats';
  }
  if (location.pathname.startsWith('/bubble')) {
    headerTitle = 'Pruebas';
  }
  if (location.pathname === '/profile') {
    headerTitle = 'Perfil';
  }
  if (location.pathname === '/support') {
    headerTitle = 'Soporte';
  }
  if (location.pathname === '/crm') {
    headerTitle = 'CRM';
  }
  
  if (location.pathname === '/analytics') {
    headerTitle = 'Analíticas';
  } else {
    const chatPathMatch = location.pathname.match(/^\/chat\/([^/]+)/);
    if (chatPathMatch) {
      headerTitle = 'Editor IA';
    }
  }

  

  // Determinar el nombre actual del asistente basado en la ruta
  let currentAssistantName = 'PAGINA';
  if (location.pathname.startsWith('/messages')) {
    currentAssistantName = 'MIS CHATS';
  }
  if (location.pathname.startsWith('/bubble')) {
    currentAssistantName = 'BURBUJA WEB';
  }
  if (location.pathname === '/profile') {
    currentAssistantName = '';
  }
  if (location.pathname === '/support') {
    currentAssistantName = 'TICKETS';
  }
  if (location.pathname === '/crm') {
    currentAssistantName = 'PANEL';
  }
  if (location.pathname === '/analytics') {
    currentAssistantName = 'ANALITICAS (PROXIMAMENTE)';
  } else {
    const chatPathMatch = location.pathname.match(/^\/chat\/([^/]+)/);
    if (chatPathMatch) {
      currentAssistantName = assistantName;
    } else if (location.pathname === '/') {
      currentAssistantName = 'MIS AGENTES'; 
    }
  }

  useEffect(() => {
  function handleOutsideClick(e) {
    // Si el modal está abierto y se hace clic afuera de ÉL y del botón:
    if (
      isUpdateModalOpen &&
      updateModalRef.current &&
      !updateModalRef.current.contains(e.target) &&
      updateButtonRef.current &&
      !updateButtonRef.current.contains(e.target)
    ) {
      setIsUpdateModalOpen(false);
      if (showUpdateNotificationIndicator) {
        markUpdateAsSeen();
        setShowUpdateNotificationIndicator(false);
      }
    }
  }

  document.addEventListener('mousedown', handleOutsideClick);
  return () => document.removeEventListener('mousedown', handleOutsideClick);
}, [isUpdateModalOpen, showUpdateNotificationIndicator]);   // deps


  return (
    <div className={`header ${isLightMode ? 'light-mode' : 'dark-mode'}`}>
      <div className="header-left">
        <h1 className="header-title">{headerTitle}</h1>
        {!location.pathname.startsWith('/profile') && (
          <button className="toggle-sidebar-button" onClick={toggleWideSidebar}>
            <img
              src={isWideSidebarVisible ? arrowRight : arrowLeft}
              alt={isWideSidebarVisible ? 'Arrow Right' : 'Arrow Left'}
              className="arrow-icon"
              style={{ width: '1.5em', height: 'auto' }} // Ajusta el tamaño aquí
            />
          </button>
        )}
        <span className="page-title">{currentAssistantName}</span>
      </div>

      <div className="header-right">

{/* Contador de Conversaciones Disponibles */}
<div className="conversation-counter paid-conversations">
  <img
    src={paidConversationsIcon}
   alt="Conversaciones Disponibles"
    className="counter-icon"
  />
 <span className="counter-badge">{totalRemainingConversations}</span>
 <span className="tooltip-text">Conversaciones disponibles</span>
</div>

  {/* Botón de Notificaciones con Modal Anidado */}
  <div className="notification-bell"
  >
          <button
            className="notification-button"
            onClick={handleBellClick}
            aria-label="Abrir notificaciones"
          >
  <img src={bellIcon} alt="Notificaciones" className="bell-icon-desktop" />
  {showNotificationIndicator && <span className="notification-indicator"></span>}

          </button>
</div>
    
    {/* Modal de Notificaciones */}
    {isModalOpen && (
  <div className="notification-modal-backdrop" onClick={() => setIsModalOpen(false)}>
    <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
      <h2 className="notification-title">Notificaciones</h2>
      <ul className="notification-list">
<li className="notification-item">
  <strong style={{ fontWeight: 600 }}>Conversaciones Restantes: </strong>
  {totalRemainingConversations <= 0 ? (
    <span> ¡Te has quedado sin conversaciones!</span>
  ) : (
    <span>
      Te quedan 
      <span className="conv-count"> {totalRemainingConversations} </span>
       conversaciones en total.
    </span>
  )}
</li>
<li className="notification-item">
  <strong style={{ fontWeight: 600 }}>Vencimiento de Suscripción: </strong>
  {daysLeftSub > 0 ? (
    <span>
      Te quedan&nbsp;
      <span className="conv-count">{daysLeftSub}</span>
      &nbsp;día{daysLeftSub > 1 ? 's' : ''} de suscripción.
    </span>
  ) : (
    <span> ¡Tu suscripción vence <span className="conv-count">hoy</span>!</span>
  )}
</li>

      </ul>
    </div>
  </div>
)}


{/* Botón de Actualizaciones */}

<div className="notification-update">
<button
  className="notification-button"
  onClick={handleUpdateClick}
  aria-label="Abrir actualizaciones"
  ref={updateButtonRef}
>

    <img src={updateIcon} alt="Actualizaciones" className="update-icon" />
    {showUpdateNotificationIndicator && <span className="notification-indicator"></span>}
  </button>
</div>

{/* Modal de Actualizaciones */}
{isUpdateModalOpen && (
  <div
    className="notification-modal-backdrop"
    onClick={() => {
      setIsUpdateModalOpen(false);
      if (showUpdateNotificationIndicator) {
        markUpdateAsSeen();
        setShowUpdateNotificationIndicator(false);
      }
    }}
  >
<div
  className="notification-actualizations-modal"
  onClick={(e) => e.stopPropagation()}
  ref={updateModalRef}
>

      <h2 className="notification-title">Actualizaciones</h2>
      <ul className="notification-list">
      <li className="notification-item">
  <span>
    <strong>Etiquetas para organizar tus chats</strong><br />
    Ahora podés ordenar tus conversaciones con <em>etiquetas</em>. Una etiqueta es un rótulo que le ponés a un chat para identificarlo rápido y poder filtrarlo después. 
    <br /><br />
    <strong>¿Para qué sirven?</strong><br />
    — Ver de un vistazo en qué estado está cada chat.<br />
    — Filtrar la lista para trabajar primero lo más importante.<br />
    — Mantener tu equipo ordenado sin hojas aparte.
    <br /><br />
    <strong>Etiquetas incluidas</strong><br />
    Tenés 3 etiquetas listas para usar: <em>Cliente potencial</em>, <em>Seguimiento</em> y <em>Descartado</em>.
    <br /><br />
    <strong>Creá las tuyas</strong><br />
    Si lo necesitás, podés crear etiquetas personalizadas con el nombre y color que quieras (por ejemplo: “Alta prioridad”, “Requiere llamada”, “Reclamo”).
    <br /><br />
    Podés poner <em>una o varias etiquetas</em> a un mismo chat, cambiarlas cuando quieras o quitarlas.
    <br /><br />
    <strong>Filtrar por etiqueta</strong><br />
    En la lista de chats, usá el filtro por etiqueta para ver solo los que te interesan (por ejemplo, todos los de <em>Seguimiento</em>).
    <br /><br />
    <strong>Importante</strong><br />
    Las etiquetas son internas: <u>tu contacto no las ve</u>. Solo sirven para tu organización y la de tu equipo.
  </span>
</li>
      <li className="notification-item">
  <span>
    <strong>Generar Resumen:</strong><br />
    Tenemos un nuevo botón llamado <em>Generar Resumen</em> diseñado especialmente para empresas o emprendimientos con un alto volumen de consultas y conversaciones extensas. Al presionarlo, la IA generará automáticamente un resumen de la conversación, intentando calificar el lead (o descalificarlo e identificar spam).
  </span>
  <div style={{ padding: '58.73% 0 0 0', position: 'relative' }}>
    <iframe 
      src="https://player.vimeo.com/video/1075335614?autoplay=1&loop=1&muted=1&background=1&badge=0&autopause=0&player_id=0&app_id=58479"
      frameBorder="0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      title="Generar Resumen"
    ></iframe>
  </div>
  <script src="https://player.vimeo.com/api/player.js"></script>
</li>

      <li className="notification-item">
  <span>
    <strong>Seguimiento Automático en Lead:</strong><br />
    Al activar el botón de <em>seguimiento individual</em>, la IA enviará un mensaje de seguimiento antes de que transcurran las 24 horas de Meta y se cierre la conversación. Este mensaje, que puede ser genérico o personalizado, permite mantener activa la conversación y recontactar al usuario sin consumir una nueva conversación ni utilizar plantillas de Meta.
  </span>
</li>
<li className="notification-item">
  <span>
    <strong>Seguimiento Global:</strong><br />
    Además del seguimiento individual, existe el <em>seguimiento global</em>: a todos los chats que no hayan superado las 24 horas se les enviará automáticamente un mensaje de seguimiento genérico. Este mensaje, que dice <em>"¿Pudiste ver mi último mensaje?"</em>, se envía a todos los leads de manera uniforme para mantener la conversación activa sin que se consuma una nueva conversación ni se gasten plantillas de Meta.
  </span>
</li>
      <li className="notification-item">
  <span>
    <strong>Nueva Funcionalidad:</strong><br />
    Ahora se pueden agregar <em>notas privadas</em> en cada chat. Estas notas son para que sólo vos y tu equipo puedan verlas, permitiéndote 
    etiquetar o hacer anotaciones internas sin que el contacto tenga acceso a esa información.
  </span>
  <div style={{ padding: '97.45% 0 0 0', position: 'relative' }}>
    <iframe 
      src="https://player.vimeo.com/video/1075335144?autoplay=1&loop=1&muted=1&background=1&badge=0&autopause=0&player_id=0&app_id=58479"
      frameBorder="0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
      title="Agregar Nota"
    ></iframe>
  </div>
  <script src="https://player.vimeo.com/api/player.js"></script>
</li>


      <li className="notification-item">
          <span><strong>¡Novedad para los amantes de los audios!</strong><br></br> Si sos de esas personas que siempre necesitan comunicarse por voz, ahora podés grabar y enviar audios directamente desde la app. Simplemente tocá el botón del micrófono para empezar a grabar, expresá todo lo que quieras decir y, cuando termines, volvé a presionarlo para detener; presioná el botón de enviar, y listo!</span>
        </li>

      <li className="notification-item">
  <span>
    <strong>Vista previa de anuncio</strong>
    <br />
    Ahora, en cada mensaje de lead verás una miniatura que indica de qué anuncio de tu campaña proviene el mensaje, permitiéndote identificar el origen del tráfico.
  </span>
  <div
    style={{
      padding: '100% 0 0 0',
      position: 'relative',
      marginTop: '1rem'
    }}
  >
    <iframe
      src="https://player.vimeo.com/video/1061010464?loop=1&autoplay=1&muted=1&background=1&badge=0&autopause=0&player_id=0&app_id=58479"
      frameBorder="0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }}
      title="Vista previa de anuncio"
    ></iframe>
  </div>
</li>

      <li className="notification-item">
                  <span>
                    <strong>Chat web totalmente personalizable</strong>
                    <br />
                    Ahora podés personalizar el chat web y la burbuja con los colores e imágenes
                    de tu web para que combine a la perfección, y ver cómo queda
                    en tiempo real gracias a nuestra vista previa.

{/* VIDEO de Vimeo AUTOPLAY LOOP */}
<div style={{ padding: '125% 0 0 0', position: 'relative', marginTop: '1rem', marginBottom: '0.5rem' }}>
  <iframe
    src="https://player.vimeo.com/video/1058598810?loop=1&autoplay=1&muted=1&background=1&badge=0&autopause=0&player_id=0&app_id=58479"
    frameBorder="0"
    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    }}
    title="Guía de personalización Chat Web The thing"
  ></iframe>
</div>
<script src="https://player.vimeo.com/api/player.js"></script>

                  </span>
                </li>

      <li className="notification-item-actualizations">
          <span><strong>Plantillas preaprobadas de Meta</strong><br></br>Incorporamos plantillas preaprobadas por meta para que, con un mensaje sencillo, puedas recontactar a cualquier contacto cuya ventana de 24 horas haya expirado, permitiéndote dar seguimiento a todas tus conversaciones sin perder oportunidades.</span>
{/* VIDEO de Vimeo AUTOPLAY LOOP */}
<div style={{ padding: '100% 0 0 0', position: 'relative', marginTop: '1rem' }}>
  <iframe
    src="https://player.vimeo.com/video/1058687174?loop=1&autoplay=1&muted=1&background=1&badge=0&autopause=0&player_id=0&app_id=58479"
    frameBorder="0"
    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    }}
    title="Envío de plantillas"
  ></iframe>
</div>
<script src="https://player.vimeo.com/api/player.js"></script>




        </li>
        
      <li className="notification-item-actualizations">
          <span><strong>¡Ahora tu agente de The Thing responde audios!</strong><br></br>Cuando llega un mensaje de voz, la app lo transcribe automáticamente para que la IA pueda leerlo y responder sin complicaciones. Además, el audio se conserva en el chat para que lo puedas escuchar cuando quieras.</span>
        </li>
      <li className="notification-item">
          <span><strong>¡Exporta tus leads a Excel con un solo clic!</strong><br></br>Ahora podés tener tus contactos clasificados en una hoja de cálculo, incluyendo teléfono, email, descripción y cualquier otro dato que quieras agregar, ideal para segmentar tu base de datos para campañas y estrategias de seguimiento.</span>
        </li>
      <li className="notification-item">
          <span><strong>¿Usás tu celular?</strong><br></br>Rediseñamos la app para que sea completamente responsive, permitiéndote acceder y trabajar desde tu celular, estés donde estés, simplemente ingresando a través de tu navegador.</span>
        </li>
      <li className="notification-item">
          <span><strong>¿Preferís usar la IA solo cuando no hay nadie para responder?</strong><br></br> Con el nuevo interruptor, desactivá la IA global en tu horario laboral y gestioná los chats manualmente. Al finalizar, activá el interruptor y la IA se encargará de atender los mensajes.</span>
        </li>
        <li className="notification-item">
          <span><strong>Perfiles para tu equipo</strong><br></br>¡Si trabajas en equipo, esta es la función que necesitabas! Ahora tus vendedores pueden crear sus propios perfiles en la app. Así, pueden elegir los chats que quieren gestionar, o recibir asignaciones específicas para iniciarlos, intervenirlos o cerrarlos mientras la IA responde.</span>
        </li>
        <li className="notification-item">
          <span><strong>¡Tenemos CRM!</strong><br></br> Clasifica, ordena y brinda seguimiento a tus clientes sin necesidad de contratar una herramienta externa, con The Thing, todo está unificado en un solo lugar.</span>
        </li>




        {/* Puedes agregar más elementos de actualización según necesites */}
      </ul>
    </div>
  </div>
)}


  </div>
  </div>

  );
};

export default Header;
 